import { _js } from '@ifixit/utils/localize';
import { faQuoteLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const BlockquoteButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('blockquote'),
      isDisabled: !editor.can().toggleBlockquote(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBlockquote().run()}
         isActive={state.isActive}
         isDisabled={state.isDisabled}
         icon={<FontAwesomeIcon icon={faQuoteLeft} />}
         title={_js('Insert a quote')}
         shortcut={'shift+b'}
      />
   );
};
